import { render, staticRenderFns } from "./DialogProduct.vue?vue&type=template&id=5a8fbc7b"
import script from "./DialogProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogProduct.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports